import { createPortal } from "react-dom";

export const getEnvironmentVariable = ( name ) => {


    return process.env[`REACT_APP_${name}`];


}

export const createUrlParams = ( params, existingParams ) => {


    const searchParams = existingParams ? existingParams : new URLSearchParams();

    for ( var prop in params ) {
        if ( !params.hasOwnProperty( prop ) || params[prop] === undefined || params[prop] === null ) continue;

        if ( Array.isArray( params[prop] ) ) {

            if ( prop === "sort" ) {
                searchParams.delete( "sort" );
            }

            for ( let i = 0; i < params[prop].length; i++ ) {
                const e = params[prop][i];
                if ( searchParams.has( prop ) && prop !== "sort" ) {
                    searchParams.set( prop, e );
                }
                else {
                    searchParams.append( prop, e );
                }
            }
            continue;
        }

        if ( searchParams.has( prop ) ) {
            searchParams.set( prop, params[prop] );
        }
        else {
            searchParams.append( prop, params[prop] );
        }
    }


    return searchParams;


}

//TODO: DRY these up
export const createGISURL = ( basePath,path="",params )=>{
    const baseUrl = `${window.location.origin}${window.baseURL}/gis/`;
    const url = new URL( `${baseUrl}${basePath}${path !== "" ? "/" + path : path}` );

    if ( !params ) return url;

    url.search = createUrlParams( params );

    return url;
}

export const createProxiedURL = ( basePath, path = "", params ) => {

    const baseUrl = `${window.location.origin}${window.baseURL}/p/`;
    const url = new URL( `${baseUrl}${basePath}${path !== "" ? "/" + path : path}` );

    if ( !params ) return url;

    url.search = createUrlParams( params );

    return url;
}


export const createApiURL = ( basePath, path = "", qParams ) => {

    const baseUrl = `${window.location.origin}${window.baseURL}/api`;
    const url = new URL( `${baseUrl}${basePath}${path !== "" ? "/" + path : path}` );

    if ( !qParams ) return url;

    url.search = createUrlParams( qParams );

    return url;


}